import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Form, Modal, Button } from 'react-bootstrap';
import { FaPlus, FaSortAmountUp, FaSortAmountDown, FaNewspaper, FaPlay, FaArrowLeft, FaArrowRight, FaEdit, FaHeart } from 'react-icons/fa';
import Navbar from '../dashboard/navbar';
import Sidebar from '../dashboard/sidebar';
import useAuth from '../dashboard/useAuth';
import { format, parseISO } from 'date-fns';
import { fr } from 'date-fns/locale';
import axios from 'axios';

const RecapitulatifExamen = ({ titre }) => {
    useAuth();
    const [examen, setExamen] = useState([]);
    const [selectedLigneQcm, setSelectedLigneQcm] = useState(null);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [isLoading, setIsLoading] = useState(false);
    const [alertModal, setAlertModal] = useState({ message: '', type: '' });
    const stored = localStorage.getItem('heureFinExamen');
    const isPause = localStorage.getItem("isPaused");
    
    // console.log('examen_id_strored : ',examen_id_strored)
    // console.log('selectedExamenid : ',selectedExamen.id)
    const [Qcms, setQcms] = useState([]); // Déclaration de l'état pour stocker les QCMs


    const user_id = localStorage.getItem('user_id');
    const { id } = useParams(); // Suppose que 'id' est dans l'URL
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const { examen_id, nbre_heures } = location.state || {};
    const { pauseChoice } = location.state || {};



    const [sortedExamen, setsortedExamen] = useState('');

    //const listeQcms = localStorage.getItem('answers');

    useEffect(() => {
        console.log('liste : ', listeQcms)
    }, [user_id]);

    const storedAnswers = localStorage.getItem('answersRecap');
    console.log('storedAnswers :', storedAnswers);

    const [listeQcms, setListeQcms] = useState(() => {
        const storedAnswers = localStorage.getItem('answersRecap');
        return storedAnswers ? JSON.parse(storedAnswers) : []; // Convertit JSON en tableau
    });

    const handleFinishExamen = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/recuperer-qcms-examenblanc/${user_id}/${examen_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (response.ok) {
                const data = await response.json();
                console.log(data)
                setQcms(data.qcms || []);  // Assurez-vous de définir un tableau vide si `resultats` est undefined
            } else {
                console.error('Erreur lors de la récupération des QCM');
                setQcms([]); // En cas d'erreur, initialise Qcms avec un tableau vide
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            setQcms([]); // En cas d'erreur réseau, initialise Qcms avec un tableau vide
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        handleFinishExamen();
    }, []);

    useEffect(() => {
        if (Qcms.length > 0 && Object.keys(listeQcms).length > 0) {
            const updatedQcms = Qcms.map(qcm => {
                // Recherche de l'élément correspondant dans listeQcms en fonction de l'id
                const correspondingQcm = listeQcms[qcm.ref];

                // Si une correspondance est trouvée, fusionner les données
                return correspondingQcm
                    ? {
                        ...qcm,
                        answers: correspondingQcm.answers,
                        index: correspondingQcm.index
                    }
                    : qcm;  // Si pas de correspondance, retourner l'objet qcm tel quel
            });

            // Mettre à jour l'état Qcms avec les données enrichies
            setsortedExamen(updatedQcms);
        } else {
            setsortedExamen(Qcms);
        }
    }, [Qcms, listeQcms]);

    useEffect(() => {
        console.log('Réponses enregistrées :', Qcms);
        console.log('Réponses listeQcms :', listeQcms);
    }, [listeQcms]);





    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const totalItems = examen.length;  // Si 'examen' contient tous les examens




    // Utilisation de useEffect pour mettre à jour le titre de la page
    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Examen"; // Définit le titre de la page
        }
    }, [user_id]);


    const isAdmin = false;
    const produit = "ExamenBlanc";
    const produit_id = localStorage.getItem('produit_id');

    // Handle alerts
    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
            //fetchExamen()
        }, 3000);
    };

    // Handle alerts modal
    const showAlertModal = (message, type = 'success') => {
        setAlertModal({ message, type });
        //fetchExamen()
    };

    const handleRowClick = (index) => {
        setSelectedLigneQcm(index);
    };


    // Pagination logic
    const indexOfLastExamen = currentPage * itemsPerPage;
    const indexOfFirstExamen = indexOfLastExamen - itemsPerPage;
    // const currentExamen = sortedExamen.slice(indexOfFirstExamen, indexOfLastExamen);
    const currentExamen = sortedExamen;
    const totalPages = Math.ceil(sortedExamen.length / itemsPerPage);

    // Handle items per page change
    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const handleRetour = (currentQcmIndex) => {
        navigate(`/Lancement-examen`, {
            state: { examen_id: examen_id, nbre_heures: nbre_heures, pauseChoice: pauseChoice },
        });
    };

    const handleRetourQuestion = (currentQcmIndex) => {
        if (examen_id) {
            navigate(`/Lancement-examen`, {
                state: { examen_id: examen_id, nbre_heures: nbre_heures },
            });
        }
        localStorage.setItem('currentQcmIndex', currentQcmIndex);
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}/`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("ExamenBlanc")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }


    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'><FaNewspaper size={25} className='mr-2' />Gestion des examens</h2>
                            <small>Plus de 2500 questions à choix multiples pour vous préparer à affronter l'examen final.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Historique-examen`}> Examens</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        {examen_id}
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>
                    <div className="mt-3">
                        <div className="wrapper wrapper-content animated fadeInRight">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5>Récapitulatif de l'examen</h5>
                                <div>
                                    <button className="btn btn-success ms-2 mr-2 mt-1" onClick={handleRetour}>
                                        <FaArrowLeft /> Retour
                                    </button>
                                    {/* <button
                                        onClick={() => handleRetourQuestion(selectedLigneQcm)}
                                        className={`btn ms-2 mr-2 mt-1 ${selectedLigneQcm ? 'btn-success' : 'btn-default text-dark'}`}
                                        disabled={!selectedLigneQcm} // Désactiver le bouton si aucune simulation n'est sélectionnée
                                    >
                                        <FaArrowLeft /> Retour à la question
                                    </button> */}
                                </div>
                            </div>

                            {alert.message && (
                                <div className={`alert alert-${alert.type}`}>
                                    {alert.message}
                                </div>
                            )}
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="ibox">
                                        <div className="ibox-content">

                                            <div className="row">
    {!isLoading ? (
        currentExamen && currentExamen.length > 0 ? (
            currentExamen.map((qcm, index) => {
                // Vérifier si c'est une question par correspondance
                const isCorrespondance = qcm.type_question === 'correspondance';
                const hasAnswers = qcm?.answers && Object.keys(qcm.answers).length > 0;
                
                // Fonction pour formater l'affichage des réponses
                const formatAnswers = (answers) => {
                    if (!answers) return "Pas de réponse";
                    
                    // Si c'est une correspondance (objet)
                    if (typeof answers === 'object' && !Array.isArray(answers)) {
                        const pairs = Object.entries(answers);
                        if (pairs.length === 0) return "Pas de réponse";
                        // Afficher les paires comme "1→2, 3→4"
                        return pairs.map(([left, right]) => `${left}→${right}`).join(", ");
                    }
                    
                    // Si c'est un tableau (questions par défaut)
                    if (Array.isArray(answers)) {
                        if (answers.length === 0) return "Pas de réponse";
                        return answers.join(", ");
                    }
                    
                    // Fallback
                    return "Pas de réponse";
                };

                const isAnswerEmpty = !qcm?.answers || 
                    (Array.isArray(qcm.answers) && qcm.answers.length === 0) ||
                    (typeof qcm.answers === 'object' && !Array.isArray(qcm.answers) && Object.keys(qcm.answers).length === 0);
                
                const rowClass = isAnswerEmpty ? 'bg-danger' : 'bg-white';

                return (
                    <div key={index} className="col-md-2 mb-3">
                        <div>
                            <table className="table table-bordered mb-0">
                                <tbody>
                                    <tr
                                        className={`text-center ${rowClass}`}
                                        onClick={() => handleRetourQuestion(index)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <td><small>{index + 1}</small></td>
                                        <td><small>{formatAnswers(qcm?.answers)}</small></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                );
            })
        ) : (
            <div className="col-12">
                <div className="alert alert-info text-center">
                    Aucune réponse enregistrée.
                </div>
            </div>
        )
    ) : (
        <div className="col-12 text-center">
            <div className="spinner-border spinner-border-lg text-success" role="status" aria-hidden="true" style={{ width: '3rem', height: '3rem' }}></div>
        </div>
    )}
</div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RecapitulatifExamen;
